import {CustomModal} from "../../../../components/CustomModal";
import Grid from "@material-ui/core/Grid";
import {FormHeader} from "../../../../components/FormHeader";
import React, {useState} from "react";
import {FormActionButtons} from "../../../../components/FormActionButton";
import {httpRequestWithAuth} from "../../../../auth/axios_instance";
import {BaseClassesChangeTimeDurationURL} from "../../../../urls";
import {Hide} from "../../../../components/Hide";
import {Loading} from "../../../../components/Loading";
import {TimeField} from "../../../../components/fields/TimeField";
import moment from "moment";
import {getLabel} from "../../../../localization/MainLocalization";
import {not_validate_value, sub_directory} from "../../../../App";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {Tooltip} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import Button from "@material-ui/core/Button";
import {BulkActionErrorTable} from "./BulkActionErrorTable";

export const ChangeTimeDurationClassModal = props => {
    const [data, setData] = useState({start_time:null, end_time:null});
    const [is_loading, setIsLoading] = useState(false)
    const [helper_text, setHelperText] = useState({})
    const [error_table_open, setErrorTableOpen] = useState(false)
    const [error_data, setErrorData] = useState([])
    const [error_columns] = useState([
        {title: getLabel("name"), field: 'class_name'},
        {title: getLabel("date"), field: 'class_date'},
        {title: getLabel("time"), field: 'class_time'},
        {title: getLabel("training_area"), field: "class_training_area"},
        {title: getLabel("start_time_error"), render:rowData=>(
                <>
                    <Hide hide={!not_validate_value.includes(rowData.start_time)}>
                        <CheckCircleIcon className="text-success"/>
                    </Hide>

                    <Hide hide={not_validate_value.includes(rowData.start_time)}>
                        <Tooltip title={rowData.start_time}>
                            <CancelIcon  color="secondary"/>
                        </Tooltip>
                    </Hide>
                </>
            )},
        {title: getLabel("end_time_error"), render:rowData=>(
                <>
                    <Hide hide={!not_validate_value.includes(rowData.end_time)}>
                        <CheckCircleIcon className="text-success"/>
                    </Hide>

                    <Hide hide={not_validate_value.includes(rowData.end_time)}>
                        <Tooltip title={rowData.end_time}>
                            <CancelIcon  color="secondary"/>
                        </Tooltip>
                    </Hide>
                </>
            )},
        {title: getLabel("general_errors"), render:rowData=>(
                <>
                    <Hide hide={!not_validate_value.includes(rowData.non_field_errors)}>
                        <CheckCircleIcon className="text-success"/>
                    </Hide>

                    <Hide hide={not_validate_value.includes(rowData.non_field_errors)}>
                        <Tooltip title={rowData.non_field_errors}>
                            <CancelIcon  color="secondary"/>
                        </Tooltip>
                    </Hide>
                </>
            )},
        {
            render: rowData => {
                return (
                    <Button
                        href={`${sub_directory}classes/?class-session=${rowData.class_id}&tag=${rowData.class_name}`}
                        target="_blank"
                        component='a'
                        size="small"
                        variant="outlined"
                    >
                        {getLabel("view")}
                    </Button>
                )
            }
        },
    ])

    const handleFieldChange = (name, newValue) => {
        let value = moment("1995-06-09 "+ newValue)

        if (name === 'start_time' && value.isAfter(moment("1995-06-09 "+ data.end_time))) {
             setData({...data,  [name]: newValue, 'end_time':newValue})
        }else if (name === 'end_time' && value.isBefore(moment("1995-06-09 "+ data.start_time))) {
             setData({...data,  [name]: newValue, 'start_time':newValue})
        }else{
             setData({...data, [name]: newValue})
        }
    }

    const handleSaveBtn = async () => {
        setHelperText({});
        await setIsLoading(true);

        let response = await httpRequestWithAuth(BaseClassesChangeTimeDurationURL, "PATCH", {details: props.details, data});

        if (response.status) {
            await props.handleModalClose(true);
        } else {
            if (Array.isArray(response.error_feedback)) {
                if (props.oneClassEdit){
                    await setHelperText(response.error_feedback[0]);
                }else{
                    setErrorData(response.error_feedback);
                    setErrorTableOpen(true);
                }
            } else {
                await setHelperText(response.error_feedback);
            }
        }

        await setIsLoading(false);
    }


    const handleModalClose = ()=>{
        setErrorTableOpen(false);
        setErrorData([]);
    }

    return (
        <CustomModal
            open={props.open}
        >
            <Grid container spacing={2}>

                <Hide hide={!error_table_open}>
                    <BulkActionErrorTable
                        open={error_table_open}
                        data={error_data}
                        columns={error_columns}
                        handleModalClose={handleModalClose}
                    />
                </Hide>

                <FormHeader
                    title="change_time_duration"
                    handleClose={()=>props.handleModalClose(false)}
                />

                <Hide hide={!is_loading}>
                    <Loading/>
                </Hide>

                <Hide hide={is_loading}>


                    <Grid item xs={12} md={6}>
                        <TimeField
                            required
                            error={helper_text.start_time !== undefined}
                            helper_text={helper_text.start_time}
                            label="start_time"
                            name="start_time"
                            value={data.start_time}
                            onChangeHandle={handleFieldChange}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <TimeField
                            required
                            error={helper_text.end_time !== undefined}
                            helper_text={helper_text.end_time}
                            label="end_time"
                            name="end_time"
                            value={data.end_time}
                            onChangeHandle={handleFieldChange}
                        />
                    </Grid>

                    <FormActionButtons
                        errorMsg={helper_text.non_field_errors}
                        handleCancelButton={()=>props.handleModalClose(false)}
                        handleSaveButton={handleSaveBtn}
                    />

                </Hide>

            </Grid>
        </CustomModal>
    )
}
